import { render } from "./DialogFiles.vue?vue&type=template&id=e1705e7c"
import script from "./DialogFiles.vue?vue&type=script&lang=js"
export * from "./DialogFiles.vue?vue&type=script&lang=js"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__